<template>
    <div class="grid grid-cols-3 overflow-hidden rounded-xs bg-red-500 text-center
        uppercase tracking-2xl text-white">
        <v-icon icon="masku-klubi-2024"
            class="col-span-1 place-self-center self-center text-8xl" />

        <strong class="col-span-2 flex flex-col px-2 py-1 font-prenton-cond font-normal">
            <span class="text-xl leading-none">
                {{ t('club-price') }}
            </span>

            <span class="text-5xl leading-none">
                {{ formatCurrency(clubPrice) }}
            </span>
        </strong>

        <div class="col-span-3 grid grid-cols-3 bg-yellow-500">
            <small class="col-span-2 col-start-2 whitespace-nowrap px-2
                font-sans-caption text-[11px] font-bold leading-relaxed text-black">
                {{ t('save', { amount: formatCurrency(clubSaving) }) }}
            </small>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    clubPrice: number
    clubSaving: number
}>();

const { t } = useI18n({
    useScope: 'local',
});

const { format: formatCurrency } = useCurrency();
</script>

<i18n lang="json">
{
    "et": {
        "club-price": "Klubihind",
        "save": "Säästa {amount}"
    },
    "fi": {
        "club-price": "Klubihinta",
        "save": "Säästä {amount}"
    }
}
</i18n>
